interface Scripts {
    name: string;
    src: string;
}
export const ScriptStore: Scripts[] = [
    // { name: 'flowplayer', src: 'https://releases.flowplayer.org/7.0.4/flowplayer.min.js' },
    // { name: 'flowplayer.hlsjs', src: 'https://releases.flowplayer.org/hlsjs/flowplayer.hlsjs.min.js' },
    // { name: 'flowplayer.hlsjs.light', src: 'https://releases.flowplayer.org/hlsjs/flowplayer.hlsjs.light.min.js' }
];